import {getLocalStorage} from 'app/utils'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const LOGOUT_USER_URL = `${API_URL}/logout`
const GET_USER_URL = `${API_URL}/getInfo`
const GET_ACCOUNTS_URL = `${API_URL}/getPuyaAccounts`
const LOGIN_PUYA_URL = `${API_URL}/khedmat-puya`

export const logoutReq = async () => {
  return axios.get(LOGOUT_USER_URL)
}

export const getMeReq = async () => {
  return axios.get(GET_USER_URL, {
    headers: {
      Authorization: `Bearer ${getLocalStorage('access_token')}`,
    },
  })
}

export const getAccountsReq = async () => {
  return axios.get(GET_ACCOUNTS_URL, {
    headers: {
      Authorization: `Bearer ${getLocalStorage('access_token')}`,
    },
  })
}

export const loginPuyaReq = async (params: any) => {
  return axios.post(LOGIN_PUYA_URL, params, {
    headers: {
      Authorization: `Bearer ${getLocalStorage('access_token')}`,
    },
  })
}
